<template>
    <div>
        <div>
            <transition-group name="slide-fade">
                <a  v-if="isBaixaDisabled()" href="javascript:;" class="btn" key="suspen"
                    v-bind:class="{ [colorSelected]: isFieldChecked('suspensos'), [colorDeselected]: !isFieldChecked('suspensos'), 'btn-circle': isButtonCircle() }"
                    v-on:click="filterSelected('suspensos')">
                    <i class="fa fa-clock-o"></i> Suspenso
                </a>
            </transition-group>
        </div>
        <hr />
        <div class="row margin-top-15">
            <div class="col-md-12">
                <a v-if="isClientesFornecedoresOrCliente()" href="javascript:;" class="btn"
                    v-bind:class="{ [colorSelected]: isFieldChecked('previsoesCre'), [colorDeselected]: !isFieldChecked('previsoesCre'),
                            'btn-circle': isButtonCircle()}"
                    v-on:click="filterSelected('previsoesCre')">
                        <i class="fa fa-dollar"></i> Previsão CRE
                </a>
                <a v-if="isClientesFornecedoresOrFornecedor()" href="javascript:;" class="btn"
                    v-bind:class="{ [colorSelected]: isFieldChecked('previsoesCpa'), [colorDeselected]: !isFieldChecked('previsoesCpa'),
                            'btn-circle': isButtonCircle()}"
                    v-on:click="filterSelected('previsoesCpa')">
                        <i class="fa fa-dollar"></i> Previsão CPA
                </a>
            </div>
        </div>

        <hr />
    </div>
</template>
<script>
    export default {
        props: ["button", "colorSelected", "colorDeselected"],
        methods: {
            isBaixaDisabled(){
                return this.$store.getters["filtro/isBaixaDisabled"];
            },
            getColorSelected() {                
                if (this.colorSelected == null || this.colorSelected == "") {
                    this.colorSelected = "green-dark";
                }
                return 'green-dark';
            },
            isButtonCircle: function () {
                return this.button == "circle";
            },
            isPriorizadoEnabled() {
                return this.$store.getters["filtro/isTituloPriorizadoEnabled"];
            },
            isFieldChecked: function (value) {
                return this.$store.state.filtro.titulo[value];
            },
            filterSelected: function (value) {
                this.$store.commit('filtro/changeTitulo', value);
            },
            isTituloEnabled() {
                return this.$store.state.filtro.abragencia.titulo;
            },
            isClientesFornecedoresOrCliente(){
                return this.$store.getters["filtro/isClientesFornecedoresOrCliente"];
            },
            isClientesFornecedoresOrFornecedor(){
                return this.$store.getters["filtro/isClientesFornecedoresOrFornecedor"];
            }
        }
    }
</script>
